"use client";
import { cn } from "@/lib/utils";
import Link from "next/link";

export function LoginButton({
  href,
  className,
}: {
  href: string;
  className?: string;
}) {
  return (
    <Link
      prefetch={false}
      href={href}
      className={cn(
        "inline-flex z-60 justify-center items-center bg-muted hover:bg-card-header/90 xl:-mb-1 px-4 py-2 rounded-4xl h-10 overflow-hidden font-medium text-secondary text-sm transition-all duration-200 cursor-pointer",
        className
      )}
    >
      Entrar com&nbsp;<span className="font-black">gov.br</span>
    </Link>
  );
}
